import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FiLink, FiShoppingCart, FiActivity, FiKey, FiRepeat, FiFileText, FiGlobe } from 'react-icons/fi';
import WooCommerce from './WooCommerce';
import AttributieKoppeling from './AttributieKoppeling';
import ApiKoppeling from './ApiKoppeling';
import ShopifyOrdersSync from './ShopifyOrdersSync';
import PayPalMt940Conversie from './PayPalMt940Conversie';
import ShopMonitor from './ShopMonitor';
import './Koppelingen.css';

const TABS = [
  { id: 'woocommerce', label: 'WooCommerce', icon: FiShoppingCart },
  { id: 'shop_monitor', label: '4shine status', icon: FiGlobe },
  { id: 'shopify_orders', label: 'Shopify → Woo orders', icon: FiRepeat },
  { id: 'attributie', label: 'Attributie koppeling', icon: FiActivity },
  { id: 'bestanden', label: 'Bestanden converteren', icon: FiFileText },
  { id: 'api', label: 'API (voorraad-feed)', icon: FiKey },
];

const TAB_IDS = new Set(TABS.map((t) => t.id));

export default function Koppelingen() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState(() =>
    tabFromUrl && TAB_IDS.has(tabFromUrl) ? tabFromUrl : 'woocommerce'
  );

  useEffect(() => {
    if (tabFromUrl && TAB_IDS.has(tabFromUrl) && tabFromUrl !== activeTab) {
      setActiveTab(tabFromUrl);
    }
  }, [tabFromUrl, activeTab]);

  const selectTab = (id) => {
    setActiveTab(id);
    setSearchParams(id === 'woocommerce' ? {} : { tab: id }, { replace: true });
  };

  return (
    <div className="koppelingen-page">
      <div className="page-header koppelingen-header">
        <h1 className="page-title"><FiLink /> Koppelingen</h1>
        <p className="page-subtitle">Koppel je webshop en tracking aan de inkoopsoftware.</p>
      </div>

      <div className="koppelingen-tabs">
        {TABS.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            type="button"
            className={`tab-btn ${activeTab === id ? 'active' : ''}`}
            onClick={() => selectTab(id)}
          >
            <Icon className="tab-icon" />
            <span>{label}</span>
          </button>
        ))}
      </div>

      <div className="koppelingen-content">
        {activeTab === 'woocommerce' && <WooCommerce />}
        {activeTab === 'shop_monitor' && <ShopMonitor />}
        {activeTab === 'shopify_orders' && <ShopifyOrdersSync />}
        {activeTab === 'attributie' && <AttributieKoppeling />}
        {activeTab === 'bestanden' && <PayPalMt940Conversie />}
        {activeTab === 'api' && <ApiKoppeling />}
      </div>
    </div>
  );
}
